import { remarkValidator } from '@/assets/js/util'

export const mobileReg = /^1[3456789]\d{9}$/
const  mobileValidator = (rule, value, callback) => {
  if (!value) {
    return callback()
  } else if (!mobileReg.test(value)) {
    return callback(new Error('手机号格式不正确'))
  } else {
    return callback()
  }
}

export const arrivalFormRules = {
  name: [
    {
      required: true,
      message: "请输入姓名",
      trigger: "blur"
    }
  ],
  gender: [
    {
      required: true,
      message: "请选择性别",
      trigger: "change"
    }
  ],
  mobile: [
    { validator: mobileValidator, trigger: 'blur' }
  ],
  accompanyType: [
    {
      required: true,
      message: "请选择陪同情况",
      trigger: "change"
    }
  ],
  accompanyNum: [
    {
      required: true,
      message: "请输入陪同人数",
      trigger: "change"
    }
  ],
  arrivalType: [
    {
      required: true,
      message: "请选择",
      trigger: "change"
    }
  ],
  arrivalDate: [
    {
      required: true,
      message: "请选择到店日期",
      trigger: "change"
    }
  ],
  arrivalMoment: [
    {
      required: true,
      message: "请选择到店时间",
      trigger: "change"
    }
    // { validator: (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('请选择时间'))
    //   } else {
    //     return callback()
    //   }
    // }, trigger: 'change' }
  ],
  receptionStaff: [
    {
      required: true,
      message: "请选择接待人员",
      trigger: "change"
    }
  ],
  arrivalPurpose: [
    { type: 'array', required: true, message: '请选择到店目的', trigger: 'change' }
  ],
  otherPurpose: [
    {
      required: true,
      message: "请输入其他目的",
      trigger: "blur"
    }
  ],
}

export const leaveFormRules = {
  customerSource: [
    {
      required: true,
      message: "请选择客户来源",
      trigger: "change"
    }
  ],
  intentionLevel: [
    {
      required: true,
      message: "请选择意向级别",
      trigger: "change"
    }
  ],
  leaveDate: [
    {
      required: true,
      message: "请选择离店日期",
      trigger: "change"
    }
  ],
  leaveMoment: [
    {
      required: true,
      message: "请选择离店时间",
      trigger: "change"
    }
  ],
  intentionSeries: [
    {
      required: true,
      message: "请选择意向车系",
      trigger: "change"
    }
  ],
  isReplacement: [
    {
      required: true,
      message: "请选择",
      trigger: "change"
    }
  ],
  paymentMethod: [
    {
      required: true,
      message: "请选择付款方式",
      trigger: "change"
    }
  ],
  hasOffer: [
    {
      required: true,
      message: "请选择",
      trigger: "change"
    }
  ],
  hasBook: [
    {
      required: true,
      message: "请选择",
      trigger: "change"
    }
  ],
  hasDeliver: [
    {
      required: true,
      message: "请选择",
      trigger: "change"
    }
  ],
  remark: [
    {
      required: true,
      validator: (...args) => {
        remarkValidator("备注", ...args)
      },
      trigger: "blur"
    }
  ],
  nextDueDate: [
    {
      required: true,
      message: "请选择跟进时间",
      trigger: "change"
    }
  ],
}

export const registerRules = {
  ...arrivalFormRules,
  ...leaveFormRules
}


